/**
 *
 * PrivateRoute
 *
 */

import React from "react"
import { connect } from "react-redux"
import { Route, Redirect } from "react-router-dom"

const PrivateRoute = (props: any) => {
	// eslint-disable-next-line
	const { component: Component, token, user, roles, ...rest } = props
	const isAuthenticated = Boolean(token) && Boolean(user)
	// `roles` is optional; when given, the route is reachable only by those roles
	const isAllowedRole = !Array.isArray(roles) || roles.includes(user?.role)

	return (
		<Route
			{...rest}
			render={(routeProps) => {
				if (!isAuthenticated) {
					return (
						<Redirect
							to={{
								pathname: "/login",
								state: { from: props.location, noAuthentication: true },
							}}
						/>
					)
				}
				if (!isAllowedRole) {
					return <Redirect to="/dashboard" />
				}
				return <Component {...routeProps} />
			}}
		/>
	)
}

const mapStateToProps = (state: any) => ({
	router: state.router,
	user: state.user,
	token: state.token,
})

export default connect(mapStateToProps)(PrivateRoute)
